module.exports = __webpack_public_path__ + "img/avoiding1.bd2917dd.svg";